import React from "react";

export default function SaleReviewPopup({
    open,
    step = 1,
    totalSteps = 1,
    eyebrow = "Validación",
    title = "Revisa la información",
    confirmLabel,
    onConfirm,
    onCancel,
    children,
}) {
    if (!open) return null;

    const currentStep = Math.max(1, Number(step || 1));
    const total = Math.max(currentStep, Number(totalSteps || 1));
    const finalLabel = confirmLabel || (
        currentStep >= total ? "Confirmar" : "Confirmar y continuar"
    );

    return (
        <div
            className="cardsSaleReviewOverlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="cards-sale-review-title"
            onMouseDown={(event) => {
                if (event.target === event.currentTarget) onCancel?.();
            }}
        >
            <div className="cardsSaleReviewCard" onMouseDown={(event) => event.stopPropagation()}>
                <div
                    className="cardsSaleReviewProgress"
                    style={{ gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))` }}
                    aria-label={`Paso ${currentStep} de ${total}`}
                >
                    {Array.from({ length: total }, (_, index) => (
                        <span
                            key={index}
                            className={index < currentStep ? "isActive" : ""}
                            aria-hidden="true"
                        />
                    ))}
                </div>

                <div className="cardsSaleReviewIcon" aria-hidden="true">✓</div>
                <div className="cardsSaleReviewEyebrow">{eyebrow}</div>
                <h3 id="cards-sale-review-title">{title}</h3>

                <div className="cardsSaleReviewContent">{children}</div>

                <div className="cardsSaleReviewFooter">
                    <button type="button" className="cardsBtnGhost" onClick={onCancel}>
                        Volver a revisar
                    </button>
                    <button type="button" className="cardsBtnPrimary" onClick={onConfirm}>
                        {finalLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
